export default __webpack_public_path__ + "static/media/logo 2.fa7135be.jpg";